<template>
  <div>

    <div class="stat-filter">
      <div class="stat-filter--first-row">
        <div class="stat-filter--second-row">
          <div class="d-flex">
            <button @click="openModal" class="btn mr-15 btn-sm">
              <span class="icon-lines">|||</span>
            </button>
            <ChoiceRange :pickerEnabled="true" :withShortcuts="true" :tz="filters.timezone" @change="onDatesChange" />
            <div class="d-flex">
              <v-select
                  v-model="filters.type"
                  :clearable="false"
                  :reduce="(option) => option.value"
                  :options="[
                  {label: 'Все типы', value: null},
                  {label: 'Push', value: 'push'},
                  {label: 'InPage', value: 'inpage'},
                  {label: 'Pop', value: 'pop'},
              ]"
                  label="label">
              </v-select>
              <v-select
                  v-model="filters.status"
                  :clearable="false"
                  :reduce="(option) => option.value"
                  :options="[
                  {label: 'Все статусы', value: null},
                  {label: 'Активные', value: true},
                  {label: 'Отключенные', value: false},
              ]"
                  label="label">
              </v-select>
              <EnableRemoteStatsCheckbox v-model="enableRemoteStats" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container">
      <vue-good-table
          styleClass="vgt-table table table-stat"
          :row-style-class="rowStyleClassFn"
          :columns="columns"
          :rows="filteredRows"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'id', type: 'desc'}
          }"
          compactMode
      >
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.tooltip" class="column-tooltip" :title="props.column.tooltip">{{ props.column.label }}</span>
          <span v-else>{{ props.column.label }}</span>
        </template>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'name'">
            <router-link class="link" :to="{ name: 'FeedId', params: { id: props.row.id }}">{{ props.row.name }}</router-link>
            <span v-if="props.row.note.length > 0" class="note" :title="props.row.note">({{ props.row.note }})</span>
          </span>
          <span v-else-if="props.column.field === 'totalClicks'" :title="clicksTitle(props.row)" style="cursor: help;">
            {{ props.row.totalClicks | formatNumber }}
          </span>
          <span v-else-if="props.column.field === 'impressions'">
            <span :title="impressionsTitle(props.row)" style="cursor: help;">{{ props.row.impressions | formatNumber }}</span>
          </span>
          <span v-else-if="props.column.field === 'expense'">
            <span :title="props.row.expense">{{ props.row.expense | formatMoney }}</span>
          </span>
          <span v-else-if="props.column.field === 'ctr'">
            <span :title="ctrTitle(props.row)" style="cursor: help;">{{ props.row.ctr | formatPercent }}</span>
          </span>
          <span v-else-if="props.column.field === 'income'">
            <span :title="props.row.income">{{ props.row.income | formatMoney }}</span>
            <span v-if="props.row.warnings.length > 0" :title="props.row.warnings.join('\n')" class="warning"> ⚠</span>
          </span>
          <span v-else-if="props.column.field === 'errors'">
            <span>{{ props.row.errors | formatNumber }}</span>
          </span>
          <span v-else-if="props.column.field === 'btn'">
            <button class="btn-link" @click="edit(props.formattedRow.id)">Редактировать</button>
          </span>
          <span v-else v-html="props.formattedRow[props.column.field]"></span>
        </template>
      </vue-good-table>
    </div>
    <source-column-modal @toggleAll="toggleAll" :toggleSelectOnce="toggleSelectOnce" :columns="columns" v-model="open" @close="close($event)" />
  </div>
</template>

<script>
import ChoiceRange from '@/components/ChoiceRange';
import EnableRemoteStatsCheckbox from '@/components/EnableRemoteStatsCheckbox.vue';
import SourceColumnModal from '@/components/sourceColumnModal.vue';
import { useEnableRemoteStats, usePreferedTimezone } from '@/utils';
import Vue from 'vue';

const timezone = usePreferedTimezone();
const enableRemoteStats = useEnableRemoteStats('feeds');

export default {
  name: 'Feeds',
  components: {
    EnableRemoteStatsCheckbox,
    SourceColumnModal,
    ChoiceRange,
  },
  data: function() {
    return {
      open: false,
      filters: {
        from: new Date(),
        to: new Date(),
        timezone: timezone,
        type: null,
        status: null,
      },
      columns: [
        {
          label: 'ID',
          field: 'id',
          type: 'number',
          hidden: false,
          checked: true,
          disabled: true,
        },
        {
          label: 'Название',
          field: 'name',
          html: true,
          hidden: false,
          checked: true,
          tdClass: 'feed-name',
          filterOptions: {
            enabled: true,
            placeholder: 'Поиск по названию фида',
            filterValue: '',
          },
        },
        {
          label: 'Тип',
          field: 'type',
          hidden: false,
          checked: true,
        },
        {
          label: 'RPS',
          field: 'rps',
          tooltip: 'Лимит запросов в секунду к фиду (настройка фида).',
          type: 'number',
          hidden: false,
          checked: true,
        },
        // {
        //   label: 'Фильтры стран',
        //   field: 'blackCountries',
        //   html: true,
        //   hidden: false,
        //   checked: true,
        // },
        // {
        //   label: 'Фильтры площадок',
        //   field: 'whitePlaces',
        //   html: true,
        //   hidden: false,
        //   checked: true,
        // },
        {
          label: 'Дискреп',
          field: 'discrep',
          tooltip: 'На сколько процентов снижаем цену фида в аукционе (настройка фида, можно переопределить по странам).',
          type: 'percentage',
          hidden: false,
          checked: true,
        },
        {
          label: 'Запросы',
          field: 'request',
          tooltip: 'Сколько запросов мы отправили в фид.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: this.$options.filters.formatNumber,
        },
        {
          label: 'Ответы',
          field: 'responses',
          tooltip: 'Ответы фида с рекламой.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: this.$options.filters.formatNumber,
        },
        {
          label: 'Пустые ответы',
          field: 'emptyResponses',
          tooltip: 'Ответы фида без рекламы.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: this.$options.filters.formatNumber,
        },
        {
          label: 'Ошибки',
          field: 'errors',
          tooltip: 'Ошибки и таймауты фида.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: this.$options.filters.formatNumber,
        },
        {
          label: 'Показы',
          field: 'impressions',
          tooltip: 'Наши показы рекламы фида. Наведите на число: показы по API фида и дискреп.',
          type: 'number',
          html: true,
          hidden: false,
          checked: true,
        },
        {
          label: 'Клики',
          field: 'totalClicks',
          tooltip: 'Наши клики по рекламе фида (без отброшенных). Наведите на число: клики по API фида и дискреп.',
          type: 'number',
          html: true,
          hidden: false,
          checked: true,
        },
        {
          label: 'Лиды',
          field: 'tbLeads',
          tooltip: 'CPA-лиды: конверсии из кликов, по которым оффер прислал постбек.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: this.$options.filters.formatNumber,
        },
        {
          label: 'CTR',
          field: 'ctr',
          tooltip: 'Наши клики / показы по API фида. Наведите на число: CTR по API фида.',
          type: 'number',
          html: true,
          hidden: false,
          checked: true,
        },
        {
          label: 'WinRate',
          field: 'winRate',
          tooltip: 'Показы по API фида / запросы в фид.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: (value) => this.$options.filters.formatPercent(value, 3),
        },
        {
          label: 'Доход (наш подсчёт)',
          field: 'expense',
          tooltip: 'Сколько фид должен нам заплатить по НАШИМ данным: цена фида за наши клики + выплаты за CPA-лиды. Выплаты вебмастерам здесь не вычитаются.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: this.$options.filters.formatMoney,
        },
        {
          label: 'Доход (по фиду)',
          field: 'income',
          tooltip: 'Сколько фид начислил нам по СВОЕМУ API. Если отличается от «Доход (наш подсчёт)» — это денежный дискреп.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: this.$options.filters.formatMoney,
        },
        {
          label: 'Выплаты вебам $',
          field: 'webmasterProfit',
          tooltip: 'Сколько мы платим вебмастерам: revshare за клики и CPA-лиды. CPL-вебам платим за подписки, а не за клики, их выплат здесь нет — маржа на их трафике завышена.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: this.$options.filters.formatMoney,
        },
        {
          label: 'Маржа $ (наш подсчёт)',
          field: 'marginOur',
          tooltip: 'Доход (наш подсчёт) − Выплаты вебам. Сколько остаётся нам по НАШИМ данным.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: this.$options.filters.formatMoney,
        },
        {
          label: 'Маржа $ (по фиду)',
          field: 'marginFeed',
          tooltip: 'Доход (по фиду) − Выплаты вебам. Сколько остаётся нам по данным фида. Пусто, если у фида нет API статистики.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: (val) => (val === null ? '—' : this.$options.filters.formatMoney(val)),
        },
        {
          label: 'Средняя цена фида',
          field: 'bidAvg',
          tooltip: 'Средняя цена в ответах фида.',
          type: 'number',
          hidden: false,
          checked: true,
          formatFn: (val) => this.$options.filters.formatMoneyWithFraction(val, 5),
        },
        {
          label: 'Время ответа (avg, p50, p90, p99)',
          field: 'tookMsAvg',
          tooltip: 'Время ответа фида в мс: среднее и перцентили p50, p90, p99.',
          type: 'number',
          hidden: false,
          checked: true,
          html: true,
          formatFn: (val, row) => {
            if (!row.tookMsQuantiles) {
              return `${row.tookMsAvg}, 0, 0, 0`;
            }
            return `${row.tookMsAvg}, ${row.tookMsQuantiles[0]}, ${row.tookMsQuantiles[1]}, ${row.tookMsQuantiles[2]}`;
          },
        },
        {
          label: 'Действия',
          field: 'btn',
          hidden: false,
          checked: true,
          disabled: true,
        },
      ],
      rows: [],
      enableRemoteStats: enableRemoteStats,
    };
  },
  computed: {
    filteredRows() {
      return this.rows.filter(row => {
        if (this.filters.type !== null && this.filters.type !== row.type) {
          return false;
        }

        if (this.filters.status !== null && (this.filters.status !== row.enabled)) {
          return false;
        }

        return true;
      });
    },
  },
  created() {
    Vue.prototype.$reload = () => this.fetchFeeds(this.filters.from, this.filters.to, this.filters.timezone);
    this.fetchFeeds(this.filters.from, this.filters.to, this.filters.timezone);
    this.setFeedsFromStorage();
  },
  methods: {
    setFeedsFromStorage() {
      const getStorage = localStorage.getItem('feedLocal');
      this.columns.forEach((e) => {
        if (getStorage) {
          if (getStorage.includes(e.field)) {
            e.hidden = false;
            e.checked = true;
          } else {
            e.hidden = true;
            e.checked = false;
          }
        }
      });
    },
    toggleAll(evt) {
      if (evt) {
        this.columns.forEach((e) => e.checked = true);
        this.columns.forEach((e) => e.hidden = false);
      } else {
        this.columns.forEach((e) => e.field !== 'id' && e.field !== 'btn' ? e.checked = false : e.checked = true);
        this.columns.forEach((e) => e.field !== 'id' && e.field !== 'btn' ? e.hidden = true : e.hidden = false);
      }
    },
    toggleSelectOnce(evt) {
      evt.hidden = !evt.checked;
    },
    close(evt) {
      const arr = [];
      this.columns.map((e) => {
        if (!e.hidden) {
          arr.push(e.field);
        }
      });
      if (evt) {
        localStorage.setItem('feedLocal', arr.toString());
      }
      this.open = false;
    },
    openModal() {
      this.open = true;
    },
    edit(id) {
      this.$router.push({
        name: 'FeedId',
        params: { id: id },
      });
    },
    async fetchFeeds(from, to, timezone) {
      try {
        this.$globalSpinner.show();

        const res = await this.$api.getFeeds(
            this.$options.filters.formatDateYmd(from),
            this.$options.filters.formatDateYmd(to),
            timezone,
            !this.enableRemoteStats,
        );

        const {
          data: feeds,
          warnings,
        } = res;

        if (warnings.length > 0) {
          console.warn('warnings', warnings);
          // this.$notification.warning('Предупреждения:\n' + warnings.map(val => ` - ${val}`).join('\n'), {timeout: 10000});
        }

        const feedWarnings = {};

        warnings.forEach((str) => {
          const match = str.match(/\(id=(\d+)\)/);
          if (match) {
            const id = match[1];
            feedWarnings[id] = [str];
          }
        });

        this.rows = feeds.map(feed => {
          return {
            id: feed.id,
            name: feed.name,
            note: feed.note,
            type: feed.type,
            enabled: feed.enabled,
            status: feed.enabled ? 'Активный' : 'Не активный',
            rps: feed.rps,
            // blackCountries: `<span title="Стран в белом списке">${feed.countryFilters.white}</span> / <span title="Стран в черном списке">${feed.countryFilters.black}</span>`,
            // whitePlaces: `<span title="Площадок в белом списке">${feed.siteFilters.white}</span> / <span title="Площадок в черном списке">${feed.siteFilters.black}</span>`,
            discrep: feed.discrep / 100,
            request: feed.requests,
            responses: feed.responses,
            emptyResponses: feed.emptyResponses,
            errors: feed.errors,
            impressions: feed.impressions,
            impressionsFromApi: feed.impressionsFromApi,
            impressionsDiscrep: feed.impressionsDiscrep,
            clicks: feed.clicks,
            tbLeads: feed.tbLeads,
            totalClicks: feed.totalClicks,
            clicksFromApi: feed.clicksFromApi,
            clicksDiscrep: feed.clicksDiscrep,
            ctr: feed.ctr,
            ctrFromApi: feed.ctrFromApi,
            ctrDiscrep: feed.ctrDiscrep,
            winRate: feed.winRate,
            expense: feed.expense,
            income: feed.income,
            webmasterProfit: feed.webmasterProfit,
            marginOur: feed.margin,
            marginFeed: feed.marginReceived,
            bidAvg: feed.bidAvg,
            tookMsAvg: feed.tookMsAvg,
            tookMsQuantiles: feed.tookMsQuantiles,
            btn: true,
            warnings: feedWarnings[feed.id] || [],
          };
        });
      } catch (err) {
        console.error(err);
        this.$notification.error('Ошибка загрузки фидов');
      } finally {
        this.$globalSpinner.hide();
      }
    },
    onDatesChange([from, to, timezone]) {
      this.filters.from = from;
      this.filters.to = to;
      this.filters.timezone = timezone;
      this.fetchFeeds(this.filters.from, this.filters.to, this.filters.timezone);
    },
    rowStyleClassFn(row) {
      return row.enabled ? '' : 'feed-disabled';
    },
    clicksTitle(row) {
      return `Клики с API фида: ${this.$options.filters.formatNumber(row.clicksFromApi)} (Дискреп ${this.$options.filters.formatPercent(row.clicksDiscrep, 0)})`;
    },
    impressionsTitle(row) {
      return `Показы с API фида: ${this.$options.filters.formatNumber(row.impressionsFromApi)} (Дискреп ${this.$options.filters.formatPercent(row.impressionsDiscrep, 0)})`;
    },
    ctrTitle(row) {
      return `CTR c кликов/показов API фида: ${this.$options.filters.formatPercent(row.ctrFromApi, 3)} (Дискреп ${this.$options.filters.formatPercent(row.ctrDiscrep, 0)})`;
    },
  },
};
</script>

<style>
.column-tooltip {
  cursor: help;
  border-bottom: 1px dotted;
}
.link {
  color: #000000;
}

.link:hover {
  text-decoration: underline;
}

.feed-disabled td, .feed-disabled a {
  color: #a0a0a0 !important;
}

.feed-name {
  display: flex;
  justify-content: left;
  align-items: center;
}

.note {
  margin-left: 5px;
  max-width: 150px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: underline;
  cursor: help;
}

.warning {
  cursor: help;
  color: #ff9800;
}
</style>
